import {
  Button,
  Card,
  IconButton,
  makeStyles,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import {
  SortableTableBody,
  SortableTableRow
} from "@saleor/components/SortableTable";
import { HotsearchList_hotSearch_edges_node } from "@saleor/hotsearch/types/HotsearchList";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection, stopPropagation } from "../../../misc";
import { ReorderAction } from "../../../types";

export interface HotSearchProps {
  hotsearch: HotsearchList_hotSearch_edges_node[];
  onReorder: ReorderAction;
  onDelete: (id: string) => void;
  onAdd: () => void;
  onUpdate: (id: string, name: string, usedfor: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    columnAdmin: {
      width: "auto",
      textAlign: "center",
      padding: 5
    },
    columnPublished: {
      width: 80,
      textAlign: "center"
    },
    columnDrag: {
      width: 48
    },
    columnOrder: {
      width: 80,
      textAlign: "center"
    },
    columnDeleteIcon: {
      width: 80,
      textAlign: "left",
      padding: 0
    },
    columnDelete: {
      width: 80,
      textAlign: "center",
      padding: 0
    },
    columnStore: {
      width: "auto",
      textAlign: "center"
    },
    dragIcon: {
      cursor: "grab"
    },
    iconCell: {
      "&:last-child": {
        paddingRight: theme.spacing()
      },
      width: 80
    },
    link: {
      cursor: "pointer"
    }
  }),
  { name: "HotSearch" }
);

const HotSearchs: React.FC<HotSearchProps> = props => {
  const { hotsearch, onReorder, onDelete, onAdd, onUpdate } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  return (
    <Card
      style={{ width: "80%", left: "15%", top: "15%", position: "absolute" }}
    >
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "HotWorld List",
          description: "section header"
        })}
        toolbar={
          <Button color="primary" onClick={onAdd}>
            <FormattedMessage
              defaultMessage="Create HotWorld"
              description="button"
            />
          </Button>
        }
      />
      <ResponsiveTable>
        <TableHead>
          <TableCell className={classes.columnDrag} />
          <TableCell className={classes.columnOrder}>
            <FormattedMessage
              defaultMessage="Order"
              description="Order header"
            />
          </TableCell>
          <TableCell className={classes.columnAdmin}>
            <FormattedMessage
              defaultMessage="Hot World"
              description="Hot World"
            />
          </TableCell>
          <TableCell className={classes.columnAdmin}>
            <FormattedMessage
              defaultMessage="Used For"
              description="Used For"
            />
          </TableCell>
          <TableCell className={classes.columnDelete}>
            <FormattedMessage
              defaultMessage="Delete"
              description="DeleteIcon header"
            />
          </TableCell>
        </TableHead>

        <SortableTableBody onSortEnd={onReorder ? onReorder : null}>
          {renderCollection(
            hotsearch,
            (hotworld, hotworldIndex) => (
              <SortableTableRow
                className={!!hotworld ? classes.link : undefined}
                hover={!!hotworld}
                key={maybe(() => hotworld.id)}
                index={hotworldIndex || 0}
                onClick={() => {
                  onUpdate(hotworld.id, hotworld.hotWord, hotworld.description);
                }}
              >
                <TableCell className={classes.columnOrder}>
                  {maybe(() => hotworld) ? hotworldIndex + 1 : <Skeleton />}
                </TableCell>
                <TableCell className={classes.columnAdmin}>
                  {maybe(() => hotworld.hotWord) ? (
                    hotworld.hotWord
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.columnAdmin}>
                  {maybe(() => hotworld.description)
                    ? hotworld.description
                    : null}
                </TableCell>

                <TableCell className={classes.columnDeleteIcon}>
                  <IconButton
                    onClick={stopPropagation(() => onDelete(hotworld.id))}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </SortableTableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={7}>
                  <FormattedMessage
                    defaultMessage="No Hot World found"
                    description="No Hot World found"
                  />
                </TableCell>
              </TableRow>
            )
          )}
        </SortableTableBody>
      </ResponsiveTable>
    </Card>
  );
};
HotSearchs.displayName = "HotSearchs";
export default HotSearchs;
